import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RewardsCardResult } from '../interfaces/rewards-card';

@Injectable({
    providedIn: 'root',
})
export class RewardsCardService {

    public constructor(
        private readonly http: HttpClient,
    ) { }

    public redeem(code: string): Observable<RewardsCardResult> {
        return this.http.post<RewardsCardResult>('/api/rewards-cards/redeem', { code });
    }
}
